import React from 'react';
import {
  ScanEanConnectorApollo,
  withMobileAppMode,
  useAppContext,
} from '@front-activerse/common-components';
import ScanBarCodeContainer from './ScanBarCodeContainer';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const ScanBarCodePage: React.FC<{ mobileAppMode: boolean; fromUserMeals?: boolean }> = ({
  mobileAppMode,
  fromUserMeals,
}) => {
  const location = useLocation();
  const aiAccess = sessionStorage.getItem('aiAccess');

  const {
    consts: { APP_BRAND },
  } = useAppContext();

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <ScanEanConnectorApollo appBrand={APP_BRAND as string}>
        {({
          scanBarcode,
          cancelScanBarcode,
        }: {
          scanBarcode: (ean: string) => Promise<unknown>;
          cancelScanBarcode: () => void;
        }) => (
          <ScanBarCodeContainer
            key={location.key}
            scanBarcode={scanBarcode}
            cancelScanBarcode={cancelScanBarcode}
            fromUserMeals={fromUserMeals}
          />
        )}
      </ScanEanConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(ScanBarCodePage);
